<template>
    <div>
        <Sidebar></Sidebar>

        <div class="content-wrapper">
            <div class="img-desktop img-desktop-term d-lg-inline-block"></div>
            <Header></Header>

            <section class="content table-content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="request-title list-title">
                            <h1>Due: consulter</h1>
                        </div>
                    </div>
                    <vuetable ref="vuetable"
                              :fields="fields"
                              :api-mode="false"
                              :data="dues"
                              no-data-template="Aucune donnée disponible"
                              class="table table-striped table-bordered"
                    >
                        <div slot="name" slot-scope="props">
                            <template v-if="props.rowData.collectiveAgreement && props.rowData.collectiveAgreement.id === 54">
                                <span v-text="`DUE neutre: ${ (props.rowData.collectiveAgreement.name).toLowerCase() }`"
                                ></span>
                            </template>
                            <template v-else-if="props.rowData.collectiveAgreement">
                                <span>DUE: </span>
                                <span>
                                    {{ props.rowData.collectiveAgreement.codeIdcc }} {{ props.rowData.collectiveAgreement.name }}
                                </span>
                            </template>

                            <span v-else> - </span>
                        </div>
                        <div slot="createdAt" slot-scope="props">
                            {{ props.rowData.createdAt | formatDateToDisplay }}
                        </div>
                        <div slot="beneficiary" slot-scope="props">
                            <span v-if="props.rowData.beneficiary">{{ props.rowData.beneficiary.shortTitle }}</span>
                            <span v-else> - </span>
                        </div>
                        <div slot="isSigned" slot-scope="props">
                            <span v-if="props.rowData.hasSignedDocument">Oui</span>
                            <span v-else>Non</span>
                        </div>
                        <div slot="effectStartDate" slot-scope="props">
                            <effect-start-date-slot
                                :effect-start-date="props.rowData.effectStartDate || ''"
                                :status="props.rowData.status"
                            ></effect-start-date-slot>
                        </div>
                        <div slot="resend" slot-scope="props">
                            <span
                                v-if="isCanResend(props.rowData.id)"
                                :class=getResendClass(props.rowData.id)
                                @click="resend(props.rowData.id)"
                            >
                                Renvoyer la notification
                            </span>
                            <span v-else> - </span>
                        </div>
                        <div slot="document" slot-scope="props">
                            <document-slot
                                v-if="isCanViewDues"
                                :dueId="props.rowData.id"
                                :amendmentDues="props.rowData.amendmentDues"
                                :isLoading="isDisabledAndLoading(props.rowData.id, 'download')"
                                :status="props.rowData.status"
                                :date="props.rowData.signedAt"
                                @download-due="downloadDueDocuments"
                                @download-amendment-due="downloadAmendmentDueDocuments"
                            ></document-slot>
                        </div>
                        <div slot="status" slot-scope="props">
                            <span v-if="props.rowData.status === 'signed' && !isCanMakeDueEffective">
                              Pour rendre opposable contactez le responsable
                            </span>
                            <button v-else-if="props.rowData.status === 'signed' && isCanMakeDueEffective"
                                    type="button"
                                    class="btn btn__enter"
                                    :disabled="isDisabledAndLoading(props.rowData.id, 'makeEffective')"
                                    @click="redirectToMakeEffectivePage(props.rowData.id)"
                            >
                                <span>Rendre opposable</span>
                                <ButtonSpinner :isLoading="isDisabledAndLoading(props.rowData.id, 'makeEffective')"
                                ></ButtonSpinner>
                            </button>
                            <span v-else-if="props.rowData.status === 'effective'">En vigueur</span>
                            <span v-else-if="props.rowData.status === 'non_effective'">Archivée</span>
                            <span v-else>En cours</span>
                        </div>
                        <div slot="actions" slot-scope="props">
                            <button v-if="props.rowData.status !== 'effective' && isCanEditDues"
                                    type="button"
                                    class="btn btn__enter"
                                    @click="edit(props.rowData.id)"
                            >Modifier</button>

                            <select
                                v-if="props.rowData.status === 'effective' && isCanEditDues"
                                @change="handleSelect($event, props.rowData)"
                                class="custom-select"
                            >
                                <option disabled selected value="default">Action</option>
                                <option value="notify">Notifier la DUE</option>
                                <option value="amendment">Avenant</option>
                            </select>
                        </div>
                    </vuetable>

                    <Paginator :items.sync="dues"
                               :pagination.sync="pagination"
                               class="float-right"
                    ></Paginator>
                </div>
            </section>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
    import Sidebar from '../../../components/Sidebar';
    import Footer from '../../../components/Footer';
    import ButtonSpinner from '../../../components/ButtonSpinner';
    import Vuetable from 'vuetable-2';
    import dueTableFields from './dueTableFields';
    import Paginator from '../../../components/Paginator';
    import Header from '../../../components/Header';
    import EffectStartDateSlot from '@/components/table/due/EffectStartDateSlot';
    import DocumentSlot from '@/components/table/due/DocumentSlot';
    import { formatDateToDisplay } from '@/utils/utils';
    import { errorMessage, messageTexts, successMessage } from '@/utils/sweet-alert-options';
    import {
        downloadDueWitSupportingDocuments,
        dueSendUpdateLink,
        fetchCompletedDues,
        isBeneficiaryCoverage,
        downloadAmendmentDueWitSupportingDocuments
    } from '@/service/api/dues.api';
    import { mapActions, mapGetters } from 'vuex';
    import permissionManager from "@/service/manager/permissionManager";
    import DueSeventhStepManager from "@/service/manager/due/seventhStepManager";

    export default {
        data() {
            return {
                fields: dueTableFields,
                dues: [],
                loading: {
                    download: {
                        isLoading: false,
                        id: null
                    },
                    makeEffective: {
                        isLoading: false,
                        id: null
                    },
                    resend: {
                        isLoading: false,
                        id: null
                    }
                },
                pagination: {
                    currentPage: 1,
                    totalItems: null,
                    itemsPerPage: 10
                },
            };
        },
        computed: {
            ...mapGetters({
                userPermissions: 'userPermissions'
            }),
            isCanViewDues() {
                return permissionManager.isCanViewDues(this.userPermissions);
            },
            isCanEditDues() {
                return permissionManager.isCanEditDues(this.userPermissions);
            },
            isCanMakeDueEffective() {
                return permissionManager.isCanMakeDueEffective(this.userPermissions);
            },
            page() {
                return this.pagination.currentPage;
            }
        },
        async created() {
            await this.fetchPaginatedDues();
            await this.fetchBeneficiaryCoverage();
        },
        methods: {
            ...mapActions({
                setIsBeneficiaryCoverage: 'setIsBeneficiaryCoverage',
            }),
            async fetchPaginatedDues() {
                const { data } = await fetchCompletedDues(this.pagination);
                this.dues = data.items;
                this.pagination.totalItems = data.totalItems;
                this.$refs.vuetable && this.$refs.vuetable.setData(this.dues);
            },
            async downloadDueDocuments(id) {
                this.loading.download.isLoading = true;
                this.loading.download.id = id;
                try {
                    await downloadDueWitSupportingDocuments(id);
                    this.loading.download.isLoading = false;
                } catch ({ response }) {
                    this.loading.download.isLoading = false;
                }
            },
            async downloadAmendmentDueDocuments({ dueId, amendmentDueId }) {
                this.loading.download.isLoading = true;
                this.loading.download.id = dueId;

                try {
                    await downloadAmendmentDueWitSupportingDocuments(amendmentDueId);

                    this.loading.download.isLoading = false;
                } catch ({ response }) {
                    this.loading.download.isLoading = false;
                }

            },
            async redirectToMakeEffectivePage(id) {
                await this.$router.push({ name: 'due-make-effective', params: { id }});
            },
            isDisabledAndLoading(id, action) {
                return this.loading[action].isLoading && this.loading[action].id === id;
            },
            async edit(dueId) {
                await this.$router.push({ name: 'due-first-step', params: { id: dueId } })
            },
            isCanResend(id) {
                const due = this.getCurrentDue(id);

                return Boolean(due.legalRepresentativeFirstName)
                    && Boolean(due.legalRepresentativeLastName)
                    && Boolean(due.legalRepresentativeEmail)
                    && due.status !== 'effective'
                ;
            },
            getResendClass(id) {
                return this.loading.resend.isLoading && this.loading.resend.id === id ? 'link-due--disabled' : 'link-due';
            },
            async resend(id) {
                this.loading.resend.isLoading = true;
                this.loading.resend.id = id;

                try {
                    const due = this.getCurrentDue(id);
                    const dueSendUpdateLinkData = {
                        "email": due.legalRepresentativeEmail,
                        "firstName": due.legalRepresentativeFirstName,
                        "isPolicyAccepted": true,
                        "lastName": due.legalRepresentativeLastName
                    };
                    await dueSendUpdateLink(
                        id,
                        DueSeventhStepManager.createSeventhStepSubmitRequest(dueSendUpdateLinkData)
                    );
                    this.$swal({ title: messageTexts.resendDueSuccess, ...successMessage });
                    this.loading.resend.isLoading = false;
                } catch ({ response }) {
                    this.loading.resend.isLoading = false;
                    this.$swal({ title: messageTexts.resendDueError, ...errorMessage });
                }
            },
            getCurrentDue(dueId) {
                return this.dues.find((due) => {
                    return due.id === dueId;
                });
            },
            async fetchBeneficiaryCoverage() {
              const { data }  = await isBeneficiaryCoverage();

              await this.setIsBeneficiaryCoverage(data.isBeneficiaryCoverage);
            },
            handleSelect(event, due) {
                const action = event.target.value;
                event.target.value = 'default';
                switch (action) {
                    case 'notify':
                        this.$router.push({ name: 'due-make-effective', params: { id: due.id } });
                        break;
                    case 'amendment':
                        this.$router.push({ name: 'due-amendment', params: { id: due.id }});
                        break;
                }
            },
        },
        watch: {
            page() {
                this.fetchPaginatedDues();
            }
        },
        filters: {
            formatDateToDisplay
        },
        components: {
            Sidebar,
            Footer,
            Vuetable,
            ButtonSpinner,
            Paginator,
            Header,
            EffectStartDateSlot,
            DocumentSlot
        }
    }
</script>
